import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import languageService from './services/languageService';

// Get the stored language preference (defaults to Czech)
const initialLanguage = languageService.initializeLanguage();

i18n
  .use(HttpApi) // Load translations using HTTP
  .use(LanguageDetector) // Detect user language (but we'll override with our stored preference)
  .use(initReactI18next)
  .init({
    lng: initialLanguage, // Use stored language or Czech default
    fallbackLng: 'cs', // Always fall back to Czech
    
    // Backend configuration to load translations from public folder
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Path to translation files in public folder
    },
    
    // Language detection configuration (we'll override this with our stored preference)
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng', // This will be overridden by our custom storage
    },
    
    interpolation: {
      escapeValue: false // React already does escaping
    },
    
    saveMissing: false,
    debug: process.env.NODE_ENV === 'development',
    
    // Ensure immediate loading
    react: {
      useSuspense: false, // Disable suspense mode to avoid loading issues
    }
  });

// Override the language detection with our custom storage
i18n.changeLanguage(initialLanguage);

// Automatically save language changes to localStorage using our service
i18n.on('languageChanged', (lng) => {
  languageService.setStoredLanguage(lng);
});

export default i18n;
